// test492
(492 && 0);
